import {
  makeProjectDonation,
  makeTKDonation,
} from "appState/donation/donationSlice";
import { useState } from "react";
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";
import InputField from "shared/InputField";
import { usePaystackPayment } from "react-paystack";
import { getProject } from "appState/project/projectSlice";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/material.css";

const Donation = ({ next, setOffline, project, projectId, ngo }) => {
  const [amount, setAmount] = useState(0);
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [active, setActive] = useState(0);

  const dispatch = useDispatch();
  const paystack = usePaystackPayment({
    amount: amount * 100,
    email: email,
    name: name,
    publicKey: process.env.REACT_APP_PS_PUBLIC_KEY,
  });

  const onSuccess = () => {
    dispatch(
      project
        ? makeProjectDonation({
            fullName: name,
            amount: amount,
            email: email,
            type: "money",
            project: projectId,
            payment_method: "card",
            ngo: ngo,
          })
        : makeTKDonation({ fullName: name, amount: amount, email: email })
    ).then((data) => {
      dispatch(getProject({ projectId: projectId }));
      if (data?.payload?.status === 200) {
        toast.success("Donated successfully");
        next();
      }
    });
  };

  const onPayStackClose = () => {
    toast.error("Oops! Payment could not be completed");
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (active === 0) {
      if (name === "" || amount < 1 || email === "") {
        toast.error("Invalid donation details!");
        return;
      } else {
        paystack(onSuccess, onPayStackClose);
      }
    } else {
      if (name === "" || phone === "" || email === "") {
        toast.error("Invalid donation details!");
        return;
      } else {
        next();
      }
    }
  };

  const donateOptions = [
    {
      title: "N500.00",
      value: 500,
    },
    {
      title: "N1,000.00",
      value: 1000,
    },
    {
      title: "N1,500.00",
      value: 1500,
    },
    {
      title: "N2,000.00",
      value: 2000,
    },
  ];

  const paymentMethod = [
    {
      title: "Credit Card",
      value: 0,
    },
    {
      title: "Offline Donation/Bank transfer",
      value: 1,
    },
  ];

  return (
    <div className="flex flex-col">
      <div>
        <form onSubmit={handleSubmit}>
          <div className="flex flex-col gap-4 py-4">
            <div className="flex">
              <div className="w-[80px] h-[55px] flex flex-col justify-center items-center hover:cursor-pointer border bor border-[#CCC] rounded-r-none rounded-md">
                <p className="text-[#213874] p-2 text-[26px] font-bold line-through">
                  N
                </p>
              </div>
              <InputField
                className="h-[50px] !rounded-l-none !border-l-0 !outline-none"
                name="amount"
                type="number"
                onChange={(e) => setAmount(parseInt(e.target.value))}
                value={amount}
              />
            </div>
            <div className="flex justify-between flex-wrap gap-4 w-full">
              {donateOptions.map((option, idx) => (
                <p
                  onClick={() => setAmount(option.value)}
                  key={idx}
                  className="cursor-pointer bg-white p-2 border w-[120px] h-[40px]"
                >
                  {option.title}
                </p>
              ))}
            </div>
          </div>
          <div className="pt-2">
            <p className="border-b p-1 text-[#213874]">Select Payment Method</p>
            <div className="flex mb-3 flex-wrap gap-5">
              {paymentMethod.map((method, idx) => (
                <div key={idx} className="">
                  <label
                    onClick={() => {
                      setActive(idx);
                      setOffline(idx);
                    }}
                    className={`flex justify-between p-2`}
                  >
                    <input
                      type="radio"
                      onChange={() => {
                        setActive(idx);
                        setOffline(idx);
                      }}
                      checked={active === method.value}
                      value={method.value}
                      name={method.value}
                    />
                    <div className="flex flex-col mx-1 gap-2">
                      <p className="text-[#213874] text-[12px] whitespace-nowrap">
                        {method.title}
                      </p>
                    </div>
                  </label>
                </div>
              ))}
            </div>
            <div>
              <div className="flex flex-col gap-4">
                <p className="border-b p-1 text-[#213874]">Personal Info</p>
                <div>
                  <InputField
                    className="border !min-h-[45px]"
                    type="text"
                    name="fullName"
                    id="fullName"
                    label="Full name"
                    placeholder="First name & Last name"
                    onChange={(e) => setName(e.target.value)}
                    value={name}
                  />
                </div>
                <div>
                  <InputField
                    className="border !min-h-[45px]"
                    type="email"
                    name="email"
                    label="Email"
                    id="email"
                    placeholder="example@test.com"
                    onChange={(e) => setEmail(e.target.value)}
                    value={email}
                  />
                </div>
                {active === 1 ? (
                  <div className="flex flex-col gap-2">
                    <label className="text-[14px] font-normal">
                      Contact Number
                    </label>
                    <PhoneInput
                      placeholder="+2349012345678"
                      country={"ng"}
                      onChange={setPhone}
                      value={phone}
                      onlyCountries={["ng"]}
                      containerClass="makeDonatePhoneInput"
                      inputProps={{
                        name: "phone",
                        required: true,
                        autoFocus: true,
                      }}
                    />
                  </div>
                ) : null}
                <button
                  type="submit"
                  className="bg-[#213874] rounded-md text-white w-full p-2"
                >
                  {active === 0 ? "Donate Now" : "View Transfer Details"}
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default Donation;
